import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import "./login.scss"
import Register from './register';
import CoursesOnboarding from './CoursesOnboarding';
import UpdateName from './name';
const WordPressLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginError, setLoginError] = useState(null);

  const [isDisplayed, setIsDisplayed] = useState(false);
  const [currentMode, setCurrentMode] = useState('login');

  useEffect(() => {

    const links = document.querySelectorAll('a');


    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        if ((link.textContent.toLowerCase().trim().startsWith('login') || link.href.includes('wp-login')) && !link.href.includes('nonce')) {
          e.preventDefault();
          setIsDisplayed(true);
        }
      });
    });

    // Also display it for new users
    if (window.location.search.includes('new_user')) {
      setIsDisplayed(true);
    }
    if (window.location.search.includes('email_confirmed')) {
      setIsDisplayed(true);
    }
    if (window.location.search.includes('nameupdate')) {
      setIsDisplayed(true);
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('/wp-json/draught/v1/login', {
        username,
        password,
      });

      if (response.data.success) {
        window.location.reload();
      }
    } catch (error) {
      setLoginError(error.response.data.message || 'Login failed. Please check your credentials.');
    }
  };

  const isLoggedIn = useMemo(() => {
    return document.body.classList.contains('logged-in');
  }, []);

  const isNewUser = useMemo(() => {
    return new URLSearchParams(window.location.search).get('new_user');
  }, []);

  const isEmailConfirmed = useMemo(() => {
    return new URLSearchParams(window.location.search).get('email_confirmed');
  }, []);

  const isNameUpdate = useMemo(() => {
    return new URLSearchParams(window.location.search).get('nameupdate');
  }, []);

  console.log(isNameUpdate, 'isNameUpdate');

  const forgotPasswordUrl = '/wp-login.php?action=lostpassword';

  if (isLoggedIn && !isNewUser && !isEmailConfirmed && !isNameUpdate) {
    return null;
  }

  return isDisplayed && (
    <>
      <div className="fixed z-50 top-0 left-0 w-full h-full flex justify-center items-center">
        <div className="fixed z-10 top-0 left-0 w-full h-full bg-white/50"
          onClick={() => setIsDisplayed(false)}
        />
        <div className="bg-white p-6 pr-2 relative overflow-y-scroll prettyscrollbar z-20 rounded mx-4 max-h-[100vh] min-w-[400px] shadow-lg shadow-slate-800/30">
          <div className="absolute -top-2 bg-white p-0 m-0 right-0 text-[30px] text-black border-0 cursor-pointer"
            style={{
              backgroundColor: "transparent",
              fontSize: "40px",
              color: "black!important",
            }}
            onClick={() => setIsDisplayed(false)}
          >&times;</div>
          {!isNewUser && !isEmailConfirmed && !isNameUpdate && currentMode === 'login' && (
            <>
              <div className="flex justify-center gap-4">
                <h3 className='text-black mb-4 text-center'>Login</h3>
                <span> or </span>

                <button className='p-0 m-0 text-black bg-transparent resetbutton'
                  onClick={() => setCurrentMode('register')}
                ><h3>Register</h3></button>

              </div>
              <form onSubmit={handleLogin} className='flex flex-col gap-6'>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Username"
                  required
                />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  required
                />
                <button type="submit" className="text-white">Login</button>

                <a href={forgotPasswordUrl} className="text-[14px] underline">Forgot your password?</a>

                {loginError && <p>{loginError}</p>}
              </form>
            </>
          )}
          {!isNewUser && currentMode === 'register' && (
            <Register currentMode={currentMode} setCurrentMode={setCurrentMode} />
          )}
          {isNewUser && (<CoursesOnboarding />)}

          {isEmailConfirmed && (
            <div>
              <h3 className='text-black mb-4 text-center'>Email confirmed!</h3>
              <p className='text-center'>
                Thank you for confirming your email.
              </p>
              <p className='text-center mb-4'>
                Please confirm your first and last name below.
              </p>
              <UpdateName />
            </div>
          )}

          {
            isNameUpdate &&
            <div>
              <h3 className='text-black mb-4 text-center'>Name updated!</h3>
              <p className='text-center'>
                Thank you for updating your name.
              </p>
              <div className="flex justify-center w-full mt-4">
                <button
                  onClick={() => window.location.href = "/draught-courses"}
                  className="text-white">Browse courses</button>
              </div>
            </div>
          }
        </div>
      </div>
    </>
  );
};

export default WordPressLogin;

